import gql from 'graphql-tag'

export default gql`
	query getDayStatistics($params: StatisticsDayParams!) {
		cashAssist {
			getDayStatistics(params: $params) {
				IntervalField
                Product
                Shop
                Total
                PriceByOne
                Amount
                Netto
			}
		}
	}
`
